import React from "react";
import Main from "./components/bottomPanel/switchPage/main/Main";
import ResultPage from "./components/bottomPanel/switchPage/result/ResultPage";
// eslint-disable-next-line import/no-cycle
import SNAPage from "./components/bottomPanel/switchPage/sna/SNAPage";

export const AIConfig = {
  content: [
    {
      name: "main",
      component: Main,
    },
    {
      name: "result",
      component: ResultPage,
    },
    {
      name: "sna",
      component: SNAPage,
    },
  ],
};
export const getAiContent = (contentName) => {

  const find = AIConfig.content.find((item) => item.name === contentName);
  if (find) {
    const { component: Component } = find;

    return <Component />;
  }
  return null;
};

export const saveDataInLostorage=(data)=>{
  localStorage.setItem("uploadTxt",data);
}